;(function(global, $)
{

	var ProfileManager = function(options){
		return new ProfileManager.init(options);
	}

	ProfileManager.prototype = {

        options: {

        },

        elevationControl: {},
		
		addEvents: function() {

            var self = this;
            $("body").on("showProfile", function(event, layerId) {
				self.closeProfile();
                self.refreshProfile(event, layerId);
			});
			
            $("body").on("closeProfile", function(event, layerId) {
                self.closeProfile(layerId);
            });
            
		},
        
        refreshProfile: function(event, layerId) {

			var self = this;
			var elevationPanelId = ".elevationPanel[data-id='" + layerId + "']";
            
			self.elevationControl[layerId] = L.control.elevation({
				useHeightIndicator: false,
				containerId: "elevation##" + layerId,
				width: 330
			});
			self.elevationControl[layerId].add(map);
			self.elevationControl[layerId].show();
			$(elevationPanelId).append(
				'<div class="profileIcons">' + 
				'<button id="profileClose" data-id="' + layerId + '" type="button" class="profileIcon close" data-dismiss="modal" aria-hidden="true">×</button>' +
				'</div>'
			);
			$(elevationPanelId).append('<div id="profileText" data-id="' + layerId + '" class="profileText" lang="ca">Calculant perfil<span class="one">.</span><span class="two">.</span><span class="three">.</span></div>');
			$(elevationPanelId).append('<div id="preloader6" data-id="' + layerId + '" class="profileLoader"><span></span><span></span><span></span><span></span></div>');
			$(elevationPanelId + " svg").hide();
			$(elevationPanelId + " .area").css({ fill: map._layers[layerId].properties.estil.color || "red" });
			$("#profileClose[data-id='" + layerId + "']").on('click', function(e){ 
				self.closeProfile(layerId);
			});

            self.fetchData(layerId);

		},
		
		closeProfile: function() {

			var self = this;
			var keys = Object.keys(self.elevationControl);
			keys.forEach((key) => {

				self.elevationControl[key].clear();
				self.elevationControl[key].hide();

			});

		},
        
        fetchData: function(layerId) {

            var self = this;
            var data = map._layers[layerId]._latlngs;
            if(data) {

                var ls = DataConverter.LatLngArrayToLineString(data);
                HeightService.fetch(ls).done(function(d,t,j) {
                    self.fetchOK(d,t,j, layerId); 
                }).fail(function(j,t,e) {
                    self.fetchKO(j,t,e);
                });

            }

        },

        fetchOK: function(data, textStatus, jqXHR, layerId) {

			this.elevationControl[layerId].addData(data.features[0]);
			var elevationPanelId = ".elevationPanel[data-id='" + layerId + "']";

            $("#profileText").hide();
            $(".profileLoader").hide();
            $(elevationPanelId + " svg").show();
        },

        fetchKO: function(jqXHR, textStatus, errorThrown) {
            console.log("Error while loading track profile: " + textStatus);
        },

	};

	ProfileManager.init = function(inOptions)
	{

		var self = this;
        self = $.extend(self, self.options, inOptions);
        self.addEvents();

	}

	ProfileManager.init.prototype = ProfileManager.prototype;

	global.ProfileManager = ProfileManager();

}(window, jQuery));
